export type ProductStockSource = {
  stock?: unknown;
  low_stock?: unknown;
};

export type ProductStockStatus = {
  label: "Out of Stock" | "Low in Stock" | "In Stock";
  tone: "out" | "low" | "in";
};

/**
 * The one availability test the PDP uses: the status row and every
 * in-stock-only promise (such as the delivery date) read it from here, so the
 * page cannot say "Out of Stock" while still promising an arrival date.
 */
export function isProductInStock(
  product: ProductStockSource | null | undefined
): boolean {
  return Boolean(product?.stock);
}

export function getProductStockStatus(
  product: ProductStockSource | null | undefined
): ProductStockStatus {
  if (!isProductInStock(product)) {
    return { label: "Out of Stock", tone: "out" };
  }
  if (product?.low_stock) {
    return { label: "Low in Stock", tone: "low" };
  }
  return { label: "In Stock", tone: "in" };
}
